import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import getBaseUrl from '../utils/getBaseUrl';

export const productMasterApi: any = createApi({
  reducerPath: 'productMaster',
  baseQuery: fetchBaseQuery({
    // baseUrl: "http://localhost:3030/",
    baseUrl: getBaseUrl(),
  }),
  endpoints: (products) => ({
    getproductmaster: products.query<{}, any>({
      query: () =>
        //  "products",
        '/appService/productcontroller/getproductmaster',
    }),
    getcadenaimage: products.query<{}, any>({
      query: (articleNumber) =>
        `/getcadenaimagedetailsbyarticlenumber?articleNumber=${articleNumber}`,
    }),
    get3DImage: products.query({
      query: (articleNumber) => ({
        url: `/appService/productcontroller/downloadcadfile?articleNumber=${articleNumber}&type=3D`,
        responseHandler: (response) => response.blob(),
      }),
    }),
  }),
});

export const {
  useGetproductmasterQuery,
  useGetcadenaimageQuery,
  useLazyGet3DImageQuery,
} = productMasterApi;
